
          window.define = __hack_curDefine;
        